export const defaultUserImages = () => `${window.location.origin}/images/profile_placeholder.png`;

export const defaultHomeImage = () => `${window.location.origin}/images/template.svg`;

export const warrantyVideo = () => `${window.location.origin}/video/wrh-video.mp4`;
